/** コンサルタント 案件詳細：データ種別 未承認 */
export const RFP_PROFESSIONAL_DATA_TYPE_UNAPPROVED = {
    label: '未承認',
    value: 'unapproved',
};
/** コンサルタント 案件詳細：データ種別 承認済（公募） */
export const RFP_PROFESSIONAL_DATA_TYPE_APPROVED_PUBLIC = {
    label: '承認済（公募）',
    value: 'approved_public',
};
/** コンサルタント 案件詳細：データ種別 承認済（RFI/業務委託） */
export const RFP_PROFESSIONAL_DATA_TYPE_APPROVED_DIRECT = {
    label: '承認済（RFI/業務委託）',
    value: 'approved_direct',
};
/** コンサルタント 案件詳細：データ種別の一覧 */
export const RFP_PROFESSIONAL_DATA_TYPES = [
    RFP_PROFESSIONAL_DATA_TYPE_UNAPPROVED,
    RFP_PROFESSIONAL_DATA_TYPE_APPROVED_PUBLIC,
    RFP_PROFESSIONAL_DATA_TYPE_APPROVED_DIRECT,
];
